import React from 'react';

type UsdtIconProps = {
  size?: number;
  className?: string;
};

const UsdtIcon: React.FC<UsdtIconProps> = ({ size = 16, className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.1532 5.14357V3.13084H14.8869V0H1.95442V3.13081H6.6877V5.1513C2.86427 5.34703 0 6.14918 0 7.10913C0 8.06905 2.86427 8.8712 6.6877 9.06697V15.3393C7.27314 15.4591 7.87921 15.5217 8.5 15.5217C9.06483 15.5217 9.61751 15.4698 10.1532 15.3702V9.07469C14.0562 8.89332 17 8.08232 17 7.10913C17 6.13595 14.0562 5.32494 10.1532 5.14357ZM8.5 8.34628C4.23508 8.34628 0.777673 7.70303 0.777673 6.90935C0.777673 6.2318 3.29728 5.66373 6.68773 5.51221V7.81359C7.2625 7.89654 7.84168 7.9382 8.4205 7.9382C8.99968 7.9382 9.57885 7.89654 10.1533 7.81359V5.50519C13.6236 5.64638 16.222 6.22108 16.222 6.90931C16.222 7.70299 12.7645 8.34628 8.5 8.34628Z"
        fill="currentColor"
      />
      <path
        d="M14.0459 10.3477C15.2704 10.3479 16.2627 11.3409 16.2627 12.5654C16.2625 13.7898 15.2702 14.782 14.0459 14.7822C12.8214 14.7822 11.8283 13.7899 11.8281 12.5654C11.8281 11.3408 12.8213 10.3477 14.0459 10.3477ZM13.3047 12.5654L14.0439 14.043L14.7832 12.5654L14.0439 11.0869L13.3047 12.5654ZM14.0439 13.4385L13.7646 12.8809L14.0439 13.0127L14.3223 12.8809L14.0439 13.4385ZM14.4404 12.4863L14.0439 12.6738L13.6465 12.4863L14.0439 11.6914L14.4404 12.4863Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default UsdtIcon;
